import React from "react";
import Reveal from "@/components/marketing/Reveal";

const STEPS = [
  { title: "Pick the package that sounds like you", desc: "Each package is framed around a sector, a region, or a goal. If it sounds like you, it was built for you." },
  { title: "We run the full mix", desc: "Placements, syndication, and outreach are handled together by our PR team. One brief, one report." },
  { title: "You get the report", desc: "A full report with live published links when the campaign completes." },
];

export default function HowPackagesWork() {
  return (
    <section className="bg-[#f7f7f9] py-10 sm:py-12 lg:py-14">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <span className="meta-tag inline-block mb-5">HOW IT WORKS</span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-bone leading-tight mb-10">How packages work</h2>
        </Reveal>
        <Reveal variant="card" delay={0.08}>
          <div className="divide-y divide-[#e8e6ef] border-t border-[#e8e6ef]">
            {STEPS.map((step, i) => (
            <div key={step.title} className="flex items-start gap-6 py-6">
              <span className="font-heading text-[28px] font-bold text-[#d8d5e2] leading-none shrink-0 w-12">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-heading text-lg font-semibold text-bone mb-1">{step.title}</h3>
                <p className="text-sm text-steel leading-relaxed">{step.desc}</p>
              </div>
            </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}